import React from 'react';

import styles from '../styles.module.scss';
import antiNukeStyles from './AntiNuke.module.scss';
import {ArrowLong} from '../../../assets';
import {AntiNukeFeature} from '../AntiNukeFeature';

export const AntiNukeCard = () => {
  return (
    <div className={antiNukeStyles.card}>
      <div className={styles.top}>
        <div className={styles.label}>
          <div className={styles.labelInner}>SECURITY</div>
        </div>
        <div className={styles.buttonForward}>
          <ArrowLong />
        </div>
      </div>
      <h4 className={styles.title}>Anti-Nuke</h4>
      <p className={styles.subTitle}>
        Themis constantly observes all members and develops a consistent pattern of behaviour. The
        bot isolates a member if a divergence.
      </p>
      <div className={antiNukeStyles.block}>
        <AntiNukeFeature />
      </div>
    </div>
  );
};
